
    import '/mnt/src/components/Tabbar/index.md?watch=parent';
    export const demoIndex = {
  ids: ["tabbar-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tabbar/index.md?type=demo')
};